import { render } from "./management.cattle.io.oidcclient.vue?vue&type=template&id=34380ba0&scoped=true"
import script from "./management.cattle.io.oidcclient.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.oidcclient.vue?vue&type=script&lang=js"

import "./management.cattle.io.oidcclient.vue?vue&type=style&index=0&id=34380ba0&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34380ba0"]])

export default __exports__